const CONSENT_LEGAL_FRAMEWORK = 'consent'
const LIA_LEGAL_FRAMEWORK = 'lia'

const CONSENT_LEGAL_FRAMEWORK_LABEL = 'Consentimento'
const LIA_LEGAL_FRAMEWORK_LABEL = 'Legitimo Interesse'

const CONSENT_LEGAL_FRAMEWORK_NAME = 'Consentimento'
const LIA_LEGAL_FRAMEWORK_NAME =
  'Legítimo interesse do controlador ou de terceiro'

const LEGAL_FRAMEWORK_NAMES = {
  [CONSENT_LEGAL_FRAMEWORK]: CONSENT_LEGAL_FRAMEWORK_NAME,
  [LIA_LEGAL_FRAMEWORK]: LIA_LEGAL_FRAMEWORK_NAME,
}

const LEGAL_FRAMEWORK_FORM_OPTIONS = [
  { id: CONSENT_LEGAL_FRAMEWORK, name: CONSENT_LEGAL_FRAMEWORK_LABEL },
  { id: LIA_LEGAL_FRAMEWORK, name: LIA_LEGAL_FRAMEWORK_LABEL },
]

const consentFormReports = {
  CONSENT_LEGAL_FRAMEWORK,
  LIA_LEGAL_FRAMEWORK,
  CONSENT_LEGAL_FRAMEWORK_LABEL,
  LIA_LEGAL_FRAMEWORK_LABEL,
  CONSENT_LEGAL_FRAMEWORK_NAME,
  LIA_LEGAL_FRAMEWORK_NAME,
  LEGAL_FRAMEWORK_NAMES,
  LEGAL_FRAMEWORK_FORM_OPTIONS,
}

export default consentFormReports
